import {useContext, useRef} from 'react'
import {Container, Box, Button} from '@mui/material'
import getFormUrl from './helpers/formUrlGenerator'
import useCurrentSelection from './helpers/useCurrentSelection'
import {AppContext} from './Context'
import {useClearRefinements} from 'react-instantsearch-hooks-web'

function Opportunities() {
	const {refine: refineAll} = useClearRefinements()
	const {selectedData} = useContext(AppContext)
	let obj = {}
	const sections = useCurrentSelection()

	const applyNowRef = useRef(null)

	function urlBuilder() {
		const queryParams = new URLSearchParams(window.location.search)
		const applicantID = queryParams.get('applicantID')
		obj = {
			applicantID: applicantID,
			city: sections.city.value,
			cluster: selectedData.current.cluster.value.join(';'),
			availability: selectedData.current.availability.value,
		}
	}

	return (
		sections.availability.hasSelected && (
			<>
				<Container disableGutters sx={{mb: 4}}>
					<Box textAlign="center" sx={{my: 4}} ref={applyNowRef}>
						<Button
							variant="outlined"
							onClick={() => refineAll()}
							// sx={{ml: 2, mt: {xs: 2, md: 0}}}
							sx={{width: 200, p: 1, m: 2}}
						>
							Reset
						</Button>
						<Button
							sx={{width: 200, p: 1, m: 2}}
							variant="outlined"
							onClick={() => {
								urlBuilder()
								window.open(getFormUrl(obj), '_self')
							}}
							disabled={
								selectedData.current.availability.hasSelected
							}
						>
							Apply Now
						</Button>
					</Box>
				</Container>
			</>
		)
	)
}

export default Opportunities
